import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';
const getToken = () => localStorage.getItem("token");

export const createCoupon = async (couponData) => {
    return axios.post(`${API_BASE_URL}/admin/promo`, couponData, {
        headers: { token: getToken() },
    });
};

export const getSingleCoupon = async (id) => {
    return axios.get(`${API_BASE_URL}/admin/promo/${id}`, {
        headers: { token: getToken() },
    });
};

export const getAllCoupons = async ({
    offset = 1,
    limit = 10,
    isActive,
    fromDate,
    toDate
} = {}) => {
    const queryParams = new URLSearchParams({
        offset,
        limit
    });

    if (isActive !== undefined && isActive !== "") {
        queryParams.append("isActive", isActive);
    }

    if (fromDate) {
        queryParams.append("fromDate", fromDate);
    }

    if (toDate) {
        queryParams.append("toDate", toDate); // send it as `toDate` in query
    }

    return axios.get(`${API_BASE_URL}/admin/promo?${queryParams.toString()}`, {
        headers: { token: getToken() },
    });
};


export const updateCoupon = async (id, payload) => {
    return axios.put(`${API_BASE_URL}/admin/promo/${id}`, payload, {
        headers: { token: getToken() },
    });
};

export const deleteCoupon = async (id) => {
    return axios.delete(`${API_BASE_URL}/admin/promo/${id}`, {
        headers: { token: getToken() },
    });
};

